var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "message-list-container" }, [
    _c("div", { staticClass: "message-list-header" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchKeywords,
            expression: "searchKeywords",
          },
        ],
        attrs: { id: "searchMessage", type: "text" },
        domProps: { value: _vm.searchKeywords },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.searchKeywords = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        { attrs: { for: "searchMessage" } },
        [
          _c("svg-icon", {
            staticClass: "icon",
            attrs: { slot: "icon", name: "search", color: "black" },
            slot: "icon",
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chatbox-close-btn", on: { click: _vm.closeChatBox } },
        [_c("i", { staticClass: "isif isif-close" })]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "message-list-body" },
      [
        _vm.newCaseConversationId
          ? _c(
              "div",
              {
                staticClass: "message-item new-message",
                on: {
                  click: function ($event) {
                    return _vm.selectConversation(_vm.newCaseConversationId)
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("instantMessaging.startConversation")) +
                    "\n      "
                ),
                _c("i", { staticClass: "isif isif-arrow-right" }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.searchResultConversations, function (conversation) {
          return [
            _c(
              "div",
              {
                key: conversation.conversationId,
                staticClass: "message-item",
                on: {
                  click: function ($event) {
                    return _vm.selectConversation(conversation.conversationId)
                  },
                },
              },
              [
                _c("div", { staticClass: "item-content" }, [
                  _c("p", { staticClass: "ellipsis" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(conversation.caseName) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ellipsis" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.displayMessageText(conversation)) +
                        "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item-info" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.displayDate(conversation.timestamp))),
                  ]),
                  _vm._v(" "),
                  conversation.unread
                    ? _c("span", { staticClass: "unread" })
                    : _vm._e(),
                ]),
              ]
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }